import type { TrackingPropsInterface, TrackingPropsCarousel } from '../../utils/enums/enums';
import type { MMediaSelectorProps } from '../../molecules/MMediaSelector/MMediaSelector.types';
import { MButtonOverlayProps } from '../../molecules/MButtonOverlay/MButtonOverlay.types';

export enum OCarouselGalleryHeroImageScale {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

/**
 * @internal
 * Used by `resolveCarouselType` to map `mCarouselControls.type` strings to
 * a typed enum. Consumers should pass raw strings via `mCarouselControls`
 * rather than importing this enum directly — it may be removed in a future
 * refactor.
 */
export enum OCarouselGalleryHeroCarouselType {
  Dots = 'Dots',
  Numbers = 'Numbers',
}

export interface OCarouselGalleryHeroProps extends React.HTMLAttributes<HTMLDivElement> {
  imageScale?: OCarouselGalleryHeroImageScale;
  /** Whether navigation wraps from the last slide back to the first. */
  loop?: boolean;
  mCarouselControls?: { type?: string; imageOverlay?: string | boolean };
  galleryButton?: string | boolean;
  virtualTourButton?: string | boolean;
  /**
   * Array of media items to display in carousel slides.
   * `mMediaCarousel` is omitted: carousel-in-carousel is not supported.
   * Valid mediaType values: Image, ModalVideo, BackgroundVideo.
   */
  mMediaSelectorMulti?: Omit<MMediaSelectorProps, 'mMediaCarousel'>[];
  mButtonOverlayGallery?: Omit<MButtonOverlayProps, 'imageOverlay'>;
  mButtonOverlayVirtualTour?: Omit<MButtonOverlayProps, 'imageOverlay'>;
  clickTrackingValues?: {
    gallery?: string;
    virtualTour?: string;
    carouselBack?: string;
    carouselForward?: string;
  };
  trackingProperties?: TrackingPropsInterface & TrackingPropsCarousel;
  className?: string;
  /** Slide count at which virtual rendering activates. Default: 10. Set to 0 to always virtualize. */
  virtualThreshold?: number;
}
